import { CreateCamiseta } from "interfaces/kitsCamiseta";
import { FormFieldConfig } from "interfaces/forms";

type fields = keyof CreateCamiseta;

const formFieldCamiseta: FormFieldConfig<fields> = {
  id: {
    name: "id",
    label: "ID",
    type: "number",
    errorMsg: "ID obrigatório",
  },
  tamanho: {
    name: "tamanho",
    label: "Tamanho",
    type: "text",
    errorMsg: "Tamanho obrigatorio",
  },
  quantidade: {
    name: "quantidade",
    label: "Quantidade",
    type: "number",
    errorMsg: "Quantidade obrigatorio",
  },
  eventId: {
    name: "eventId",
    label: "ID Evento",
    type: "number",
    errorMsg: "ID Evento obrigatorio",
  },
};

export default formFieldCamiseta;
